var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetergentPouch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.999,
    height: 37,
    viewBox: "0 0 32.999 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ON",
    transform: "translate(0 0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9862",
    "data-name": "Group 9862",
    transform: "translate(0 0.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9861",
    "data-name": "Group 9861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M30.174,12.339V33.266a2.431,2.431,0,0,1-2.43,2.42h-24a2.424,2.424,0,0,1-2.43-2.42V3.78A2.431,2.431,0,0,1,3.74,1.36H18.413a4.208,4.208,0,0,1,2.98,1.23l3.21,3.2,1.41,1.4,3.461,3.44A2.438,2.438,0,0,1,30.174,12.339Z",
    transform: "translate(0 -0.06)",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M27.754,37H3.741A3.737,3.737,0,0,1,0,33.276V3.779A3.737,3.737,0,0,1,3.741.06H18.413a5.594,5.594,0,0,1,3.911,1.61l8.071,8.039a3.707,3.707,0,0,1,1.09,2.63V33.266A3.73,3.73,0,0,1,27.754,37ZM3.741,2.67a1.114,1.114,0,0,0-1.11,1.11v29.5a1.114,1.114,0,0,0,1.11,1.11H27.754a1.114,1.114,0,0,0,1.11-1.11V12.338a1.089,1.089,0,0,0-.33-.78L20.463,3.52a2.931,2.931,0,0,0-2.06-.85H3.741Z",
    transform: "translate(0 -0.06)",
    fill: "#e9cc63"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9864",
    "data-name": "Group 9864",
    transform: "translate(7.283 4.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9863",
    "data-name": "Group 9863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M7.41,23.967c-.75,5.379,2.04,7.589,2.18,7.7l.13.1h.16c.03,0,3.771.04,8.031.04,1.64,0,3.15-.01,4.511-.02h.06l.05-.01a1.9,1.9,0,0,0,1.42-1.21,3.682,3.682,0,0,0-.16-2.37c-.06-.16-.12-.31-.18-.46l-.01-.02a3.455,3.455,0,0,1-.18-.47,4.834,4.834,0,0,1-.2-1.74,16.092,16.092,0,0,1,.34-2.21c.07-.32.15-.65.23-.98a11.193,11.193,0,0,0,.43-2.73,14.83,14.83,0,0,0-.41-3.42,10.159,10.159,0,0,0-2.09-4.129,8.863,8.863,0,0,0-2.45-2c-.05-.03-.1-.06-.16-.09a4.016,4.016,0,0,0-.69-.33V7.42a2.731,2.731,0,0,0-2.73-2.72h-2.55a2.725,2.725,0,0,0-2.73,2.72v2.39c-.26.3-1.05,1.22-1.58,1.75a2.456,2.456,0,0,0-.62,2.75c.05.15,1.17,3.739-.04,6.5l-.01.04a28.924,28.924,0,0,0-.72,3.01Zm15.062-4.359c-.04.22-.3,1.33-1.02,1.63a.843.843,0,0,1-.35.07,1.222,1.222,0,0,1-.96-.58,10.743,10.743,0,0,1-2.29-6.479,1.593,1.593,0,0,1,.19-.8,1.017,1.017,0,0,1,.72-.49,3.028,3.028,0,0,1,1.99.58,5.809,5.809,0,0,1,1.83,3.58A6.741,6.741,0,0,1,22.472,19.608ZM18.2,10.089H10.6a.079.079,0,0,1-.08-.08v-.64a.079.079,0,0,1,.08-.08h7.6a.079.079,0,0,1,.08.08v.64A.074.074,0,0,1,18.2,10.089Z",
    transform: "translate(-7.282 -4.7)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9865",
    "data-name": "Group 9865",
    transform: "translate(23.859 -0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    "data-name": "Path 3899",
    d: "M28.621,9.029,23.93,4.359a.278.278,0,0,1,0-.38L27.851.07a.278.278,0,0,1,.38,0l4.691,4.669a.278.278,0,0,1,0,.38L29,9.029A.26.26,0,0,1,28.621,9.029Z",
    transform: "translate(-23.855 0.005)",
    fill: "#e9cc63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetergentPouch);
export default __webpack_public_path__ + "static/media/detergent_pouch.a994674646f32f3ace6d99080128fb4c.svg";
export { ForwardRef as ReactComponent };